<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200 } = $AppState.theme.colors;
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20.5 6.75C20.5 5.7875 19.7125 5 18.75 5H4.75C3.7875 5 3 5.7875 3 6.75M20.5 6.75V17.25C20.5 18.2125 19.7125 19 18.75 19H4.75C3.7875 19 3 18.2125 3 17.25V6.75M20.5 6.75L11.75 12.875L3 6.75"
    stroke={primary200}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
